export function TitleCase (value: string): string {
  const res: string[] = [];
  if (value) {
    const vals = value.split('_');
    vals.forEach(v => {
      res.push(v.substring(0, 1).toUpperCase() + v.substring(1).toLowerCase());
    });
  }
  return res.join('');
}

export function kebab (value: string): string {
  const res = value.replace('(?<!^)([A-Z][a-z]|(?<=[a-z])[A-Z])', '-$1').replaceAll('_', '-').toLowerCase()
  return res;
}

export function reference (prefix: string, value: number): string {
  if (value < 10) {
    return prefix + '-00000' + value.toString();
  } else if (value < 100) {
    return prefix + '-0000' + value.toString();
  } else if (value < 1000) {
    return prefix + '-000' + value.toString();
  } else if (value < 10000) {
    return prefix + '-00' + value.toString();
  } else if (value < 100000) {
    return prefix + '-0' + value.toString();
  } else {
    return prefix + '-' + value.toString();
  }

}

export function upperCase (value: string): string {
  return value.toUpperCase();
}

export function lowerCase (value: string): string {
  return value.toLowerCase();
}

export function ascii (value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function asciiLowerCase (value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();;
}

export function hasHtml (value: string): boolean {
  return /<[a-z][\s\S]*>/i.test(value);
}

